import { Link } from "react-router-dom";
import styled from "styled-components";

export const Btn = styled(Link)`
  width: 302px;
  height: 76px;
  min-height: 76px;
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  box-shadow: 3px 7px 11px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  color: var(--color-white);
  font-weight: 500;
  font-size: 20px;
  line-height: 150%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  padding-left: 30px;
  text-decoration: none;
  margin: auto;
  text-align: start;
  .ptur-tildeOk-autocheckin {
    width: 42px;
    height: 32px;
    padding: 2px;
  }
`;

export const BtnNormal = styled.button`
  width: 302px;
  height: 76px;
  min-height: 76px;

  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  box-shadow: 3px 7px 11px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
  color: var(--color-white);
  font-weight: ${({$normalFont}) => $normalFont ? "400" : "500"};;
  font-size: 20px;
  line-height: 150%;
  display: flex;
  justify-content: ${({$textCentre}) => $textCentre ? "center" : "flex-start"};
  align-items: center;
  gap: 20px;
  padding-left: ${({$textCentre}) => $textCentre ? "0px" : "30px"};
  text-decoration: none;
  margin: auto;
  text-align: ${({$textCentre}) => $textCentre ? "center" : "start"};
  
  ${
    ({$spacingWord}) => ($spacingWord ? "word-spacing: 10px;": "")
  }
  .ptur-tildeOk-autocheckin {
    width: 42px;
    height: 32px;
    padding: 2px;
  }
`;


export const BtnGreen = styled(BtnNormal)`
  background: var(--color-green-gradient);
`;